import { j as o } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as i } from "react";
import { I as l } from "../../../../IconBase-CxZyIWw2.js";
const s = i(
  (a, e) => /* @__PURE__ */ o.jsx(
    l,
    {
      ref: e,
      ...a,
      image: (r) => /* @__PURE__ */ o.jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: 16,
          height: 16,
          fill: "none",
          viewBox: "0 0 16 16",
          ...r,
          children: /* @__PURE__ */ o.jsx(
            "path",
            {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M4 4a4 4 0 1 1 8 0h2a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1zm2 0a2 2 0 1 1 4 0z",
              clipRule: "evenodd"
            }
          )
        }
      )
    }
  )
);
s.displayName = "BagIcon";
export {
  s as BagIcon,
  s as default
};
//# sourceMappingURL=index.js.map
